/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomFieldReference,
    CustomFieldReferenceFromJSON,
    CustomFieldReferenceFromJSONTyped,
    CustomFieldReferenceToJSON,
    JobReference,
    JobReferenceFromJSON,
    JobReferenceFromJSONTyped,
    JobReferenceToJSON,
    VolumeReference,
    VolumeReferenceFromJSON,
    VolumeReferenceFromJSONTyped,
    VolumeReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaRootDetailPartialUpdate
 */
export interface MediaRootDetailPartialUpdate {
    /**
     * 
     * @type {Array<CustomFieldReference>}
     * @memberof MediaRootDetailPartialUpdate
     */
    customFields?: Array<CustomFieldReference>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaRootDetailPartialUpdate
     */
    workflow?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {VolumeReference}
     * @memberof MediaRootDetailPartialUpdate
     */
    volume?: VolumeReference;
    /**
     * 
     * @type {Array<JobReference>}
     * @memberof MediaRootDetailPartialUpdate
     */
    jobs?: Array<JobReference>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaRootDetailPartialUpdate
     */
    aiConfig?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailPartialUpdate
     */
    readonly path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    needsRescan?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailPartialUpdate
     */
    viewMode?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailPartialUpdate
     */
    viewStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailPartialUpdate
     */
    viewDefaultTab?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    showTags?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    showComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    showLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    showCustomFields?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    showRatings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    showSubclips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    showSubtitles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    showMarkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    showHistory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    showAiMetadata?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    prefetchThumbnailStrips?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailPartialUpdate
     */
    cover?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailPartialUpdate
     */
    nameField?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailPartialUpdate
     */
    shareComments?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetailPartialUpdate
     */
    shareLinkDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetailPartialUpdate
     */
    defaultProxyProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetailPartialUpdate
     */
    cloudProxyProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetailPartialUpdate
     */
    aiConnection?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetailPartialUpdate
     */
    aiProxyProfile?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRootDetailPartialUpdate
     */
    proxyProfiles?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRootDetailPartialUpdate
     */
    tags?: Array<number>;
}

export function MediaRootDetailPartialUpdateFromJSON(json: any): MediaRootDetailPartialUpdate {
    return MediaRootDetailPartialUpdateFromJSONTyped(json, false);
}

export function MediaRootDetailPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaRootDetailPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customFields': !exists(json, 'custom_fields') ? undefined : ((json['custom_fields'] as Array<any>).map(CustomFieldReferenceFromJSON)),
        'workflow': !exists(json, 'workflow') ? undefined : json['workflow'],
        'volume': !exists(json, 'volume') ? undefined : VolumeReferenceFromJSON(json['volume']),
        'jobs': !exists(json, 'jobs') ? undefined : ((json['jobs'] as Array<any>).map(JobReferenceFromJSON)),
        'aiConfig': !exists(json, 'ai_config') ? undefined : json['ai_config'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'needsRescan': !exists(json, 'needs_rescan') ? undefined : json['needs_rescan'],
        'viewMode': !exists(json, 'view_mode') ? undefined : json['view_mode'],
        'viewStyle': !exists(json, 'view_style') ? undefined : json['view_style'],
        'viewDefaultTab': !exists(json, 'view_default_tab') ? undefined : json['view_default_tab'],
        'showTags': !exists(json, 'show_tags') ? undefined : json['show_tags'],
        'showComments': !exists(json, 'show_comments') ? undefined : json['show_comments'],
        'showLocations': !exists(json, 'show_locations') ? undefined : json['show_locations'],
        'showCustomFields': !exists(json, 'show_custom_fields') ? undefined : json['show_custom_fields'],
        'showRatings': !exists(json, 'show_ratings') ? undefined : json['show_ratings'],
        'showSubclips': !exists(json, 'show_subclips') ? undefined : json['show_subclips'],
        'showSubtitles': !exists(json, 'show_subtitles') ? undefined : json['show_subtitles'],
        'showMarkers': !exists(json, 'show_markers') ? undefined : json['show_markers'],
        'showHistory': !exists(json, 'show_history') ? undefined : json['show_history'],
        'showAiMetadata': !exists(json, 'show_ai_metadata') ? undefined : json['show_ai_metadata'],
        'prefetchThumbnailStrips': !exists(json, 'prefetch_thumbnail_strips') ? undefined : json['prefetch_thumbnail_strips'],
        'cover': !exists(json, 'cover') ? undefined : json['cover'],
        'nameField': !exists(json, 'name_field') ? undefined : json['name_field'],
        'shareComments': !exists(json, 'share_comments') ? undefined : json['share_comments'],
        'shareLinkDuration': !exists(json, 'share_link_duration') ? undefined : json['share_link_duration'],
        'defaultProxyProfile': !exists(json, 'default_proxy_profile') ? undefined : json['default_proxy_profile'],
        'cloudProxyProfile': !exists(json, 'cloud_proxy_profile') ? undefined : json['cloud_proxy_profile'],
        'aiConnection': !exists(json, 'ai_connection') ? undefined : json['ai_connection'],
        'aiProxyProfile': !exists(json, 'ai_proxy_profile') ? undefined : json['ai_proxy_profile'],
        'proxyProfiles': !exists(json, 'proxy_profiles') ? undefined : json['proxy_profiles'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
    };
}

export function MediaRootDetailPartialUpdateToJSON(value?: MediaRootDetailPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'custom_fields': value.customFields === undefined ? undefined : ((value.customFields as Array<any>).map(CustomFieldReferenceToJSON)),
        'workflow': value.workflow,
        'volume': VolumeReferenceToJSON(value.volume),
        'jobs': value.jobs === undefined ? undefined : ((value.jobs as Array<any>).map(JobReferenceToJSON)),
        'ai_config': value.aiConfig,
        'name': value.name,
        'needs_rescan': value.needsRescan,
        'view_mode': value.viewMode,
        'view_style': value.viewStyle,
        'view_default_tab': value.viewDefaultTab,
        'show_tags': value.showTags,
        'show_comments': value.showComments,
        'show_locations': value.showLocations,
        'show_custom_fields': value.showCustomFields,
        'show_ratings': value.showRatings,
        'show_subclips': value.showSubclips,
        'show_subtitles': value.showSubtitles,
        'show_markers': value.showMarkers,
        'show_history': value.showHistory,
        'show_ai_metadata': value.showAiMetadata,
        'prefetch_thumbnail_strips': value.prefetchThumbnailStrips,
        'cover': value.cover,
        'name_field': value.nameField,
        'share_comments': value.shareComments,
        'share_link_duration': value.shareLinkDuration,
        'default_proxy_profile': value.defaultProxyProfile,
        'cloud_proxy_profile': value.cloudProxyProfile,
        'ai_connection': value.aiConnection,
        'ai_proxy_profile': value.aiProxyProfile,
        'proxy_profiles': value.proxyProfiles,
        'tags': value.tags,
    };
}


